__turbopack_context__.v({
  "breadcrumbs": "Breadcrumbs-module-scss-module__Ir3W5a__breadcrumbs",
  "clickableCrumb": "Breadcrumbs-module-scss-module__Ir3W5a__clickableCrumb",
  "crumb": "Breadcrumbs-module-scss-module__Ir3W5a__crumb",
  "dark": "Breadcrumbs-module-scss-module__Ir3W5a__dark",
  "light": "Breadcrumbs-module-scss-module__Ir3W5a__light",
  "separator": "Breadcrumbs-module-scss-module__Ir3W5a__separator",
});
